import React from 'react';
import notfound from "../../assets/imgs/404.png";

const NotFound = () => {
  return (
    <div className='container py-3'>
     <div className='flex flex-col gap-1 items-center'>
     <h1 className='heading-one pb-2'>Page Not Found</h1>
        <div className='flex justify-between items-center'>
            <div className='w-full h-full'>
                <img src={notfound} className='w-[500px] h-[500px]' alt='not found' />
            </div>
        </div>
     </div>
    </div>
  )
}

export default NotFound